import { render, staticRenderFns } from "./alarmProfile.vue?vue&type=template&id=6879c281&"
import script from "./alarmProfile.vue?vue&type=script&lang=js&"
export * from "./alarmProfile.vue?vue&type=script&lang=js&"
import style0 from "./alarmProfile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports